import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=23a2fbbe&scoped=true"
import script from "./AddressItem.vue?vue&type=script&lang=js"
export * from "./AddressItem.vue?vue&type=script&lang=js"
import style0 from "./AddressItem.vue?vue&type=style&index=0&id=23a2fbbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a2fbbe",
  null
  
)

export default component.exports